<template>
    <v-container fluid fill-height class="console-terms">
        <v-layout justify-center>
            <v-responsive max-width="auto" width="100%">
                <v-row class="mt-8" justify="center" align="center">
                    <v-col cols="auto" class="pt-0 pb-0 headline text-start">메인 빅데이터 카운트 관리</v-col>
                    <v-spacer></v-spacer>
                </v-row>

                <v-card class="mt-4">
                    <v-card-text class="py-3">
                        <v-row>
                            <div class="mx-4"><span class="caption primary--text">* 숫자만 기입 가능합니다.</span></div>
                        </v-row>
                        <v-row>
                            <v-col> <v-text-field v-model="main.domesitc" type="number" label="(주)이레아이에스 국내 사용지역" persistent-placeholder outlined dense hide-details /> </v-col>
                            <v-col> <v-text-field v-model="main.overseas" type="number" label="(주)이레아이에스 해외 사용지역" persistent-placeholder outlined dense hide-details /> </v-col>
                            <v-col> <v-text-field v-model="main.farmhouse" type="number" label="사용 농가" persistent-placeholder outlined dense hide-details /> </v-col>
                            <v-col> <v-text-field v-model="main.data" type="number" label="농가 데이터 센서 수" persistent-placeholder outlined dense hide-details /> </v-col>
                            <v-col> <v-text-field v-model="main.dataCollection" type="number" label="1일 데이터 수집량" persistent-placeholder outlined dense hide-details /> </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-spacer />
                        <v-btn text color="primary" @click="save">저장</v-btn>
                    </v-card-actions>
                </v-card>
            </v-responsive>
        </v-layout>
    </v-container>
</template>

<script>
import api from "@/api";

export default {
    data() {
        return {
            main:{
                domesitc: 0,
                overseas: 0,
                farmhouse: 0,
                data: 0,
                dataCollection: 0,
            }
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { main } = await api.console.ireis.main.get();
            if(main) this.main = main;
        },
        async save() {
            let { main } = await api.console.ireis.main.get();
            if(!main) {
                console.log(this.main);
                await api.console.ireis.main.post(this.main);
                alert("저장되었습니다.")
            }
            else {
                await api.console.ireis.main.put(this.main);
                alert("수정되었습니다.");
            }
            this.init()
        },
    },
};
</script>
